import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiService {
  public lang: string;
  constructor(private http: HttpClient) {}
  addParamLenguage(params) {
    params.lang = this.lang;
    return params;
  }
  get (resource, params = {})  {
    params = this.addParamLenguage(params);
    return this.http.get(environment.urlBase + resource, {params: params});
  }

  post (resource, data) {
    return this.http.post(environment.urlBase + resource, data);
  }

  getDataIdiomas(resource, params = {})  {
        return this.http.get(environment.urlBase + resource, {params: params});
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/api.service.ts